export const initialState = {
  isLoggedIn: false,
  first_name: '',
}